import React, { useEffect, useState } from 'react';
import { fetchStockId } from '../../utils/marketsUtils';
import { DatabaseOutlineIcon } from '../../../../atoms/material-icons';
import './compare-valuation.m.css';
import EmptyState from '../empty-state';
import { useInterval } from '../../../../../helpers/custom-hooks';
import { isWithinTradingHours } from '../../../../../helpers/utils';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

const CompareValuation = () => {
  const [peerDetailsData, setPeerDetailsData] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const tradingHolidays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'trading_holidays'], []),
  );
  const specialTradingDays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'special_trading_days'], {}),
  );

  const getDeliveryVolumeData = async (stockId) => {
    const response = await fetch(`/next/feapi/stock/peer-details/${stockId}`);
    const data = await response.json();
    setPeerDetailsData(data?.data);
  };

  useEffect(() => {
    if (initialLoading) {
      const retrievedStockId = fetchStockId();
      getDeliveryVolumeData(retrievedStockId);
      setInitialLoading(false);
    }
  }, []);

  useInterval(() => {
    if (isWithinTradingHours(tradingHolidays, specialTradingDays)) {
      const retrievedStockId = fetchStockId();
      getDeliveryVolumeData(retrievedStockId);
    }
  }, 30000);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="compare-valuation-container">
      <div styleName="header-title-container">
        <DatabaseOutlineIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">COMPARE VALUATION</h2>
      </div>
      {peerDetailsData?.length > 0 ? (
        <>
          <div styleName="peer-details-body">
            <table>
              <tr styleName="fix-header">
                <th>Company</th>
                <th>PE</th>
                <th>EV/EBIDTA</th>
                <th>PEG RATIO</th>
              </tr>
              {peerDetailsData?.map((detail) => {
                return (
                  <tr key={detail?.sid}>
                    <td styleName="short-name">{detail?.['short_name']}</td>
                    <td>{detail?.pe}</td>
                    <td>{detail?.['ev_ebidta']}</td>
                    <td>{detail?.['peg_ratio']}</td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div styleName="space-manager"></div>
        </>
      ) : (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState subTextMessage={'for this stock at the moment'} />
          </div>
        </div>
      )}
    </div>
  );
};

export default CompareValuation;
